import React, { useState, useEffect } from 'react';
import {
  Box,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Alert,
  CircularProgress,
} from '@mui/material';
import { adminAPI } from '../../utils/api';
import { formatToBogotaTime } from '../../utils/dateUtils';

const ViewerList = ({ refresh }) => {
  const [viewers, setViewers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadViewers();
  }, [refresh]);

  const loadViewers = async () => {
    setLoading(true);
    setError('');

    try {
      const data = await adminAPI.getViewers();
      setViewers(data.viewers);
    } catch (err) {
      setError(err.message || 'Failed to load viewers');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Assessment Viewers
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {viewers.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          No viewers created yet.
        </Typography>
      ) : (
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell><strong>Email</strong></TableCell>
                <TableCell><strong>Created At</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {viewers.map((viewer) => (
                <TableRow key={viewer.id}>
                  <TableCell>{viewer.email}</TableCell>
                  <TableCell>
                    {formatToBogotaTime(viewer.created_at)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Paper>
  );
};

export default ViewerList;
